import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=3caef77b"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports